import useTLO from "./useTLO"
import API from "./api"

export default function useAsset(id) {
  const asset = useTLO("asset", id)

  async function addLocation(location) {
    await API.post(`/assets/${id}/locations`, location)
    asset.refresh()
  }

  async function removeLocation(locationId) {
    await API.delete(`/assets/${id}/locations/${locationId}`)
    asset.refresh()
  }

  if (asset !== undefined) {
    asset.addLocation = addLocation
    asset.removeLocation = removeLocation
  }

  return asset
}
